import {Button, Space, Tooltip} from "antd";
import moment from "moment";
import {EmptyState} from "../../../../../../../empty-state";
import {
  ServiceOrderWorkDeliveryDeliveredWorkCustomerReview,
  ServiceOrderWorkDeliveryDeliveredWorkLinkList,
} from "../../../../card/drawer/order-info/work-delivery/delivered-work/link-list";
import {CustomerServiceOrderWorkDeliveryProps} from "..";
import {useGetCustomerStoreServicesOrdersContext} from "../../../../../../../../service-feature/useCases/get-orders/context/customer";
import {Fragment} from "react";
import {StyledNoUpcomingCallBox} from "../../../../../../../calls/upcoming-calls/upcoming-calls.style";

export type CustomerServiceOrderWorkDeliveryDeliveredWorkProps = {
  productServiceDeliveries: CustomerServiceOrderWorkDeliveryProps["productServiceDeliveries"];
  status: CustomerServiceOrderWorkDeliveryProps["status"];
  deliveryDate: CustomerServiceOrderWorkDeliveryProps["deliveryDate"];
};

export function CustomerServiceOrderWorkDeliveryDeliveredWork({
  productServiceDeliveries,
  status,
  deliveryDate,
}: CustomerServiceOrderWorkDeliveryDeliveredWorkProps) {
  const {dispatch} = useGetCustomerStoreServicesOrdersContext();

  const sortedProductServiceDeliveries = productServiceDeliveries.sort((a, b) => {
    const aHasComment = !!a.customer_comment;
    const bHasComment = !!b.customer_comment;

    return Number(bHasComment) - Number(aHasComment);
  });

  const hasBeenReviewed = sortedProductServiceDeliveries.some(
    (item) => item.customer_comment != null && item.customer_comment !== ""
  );

  // delivery date + 1 day
  const enableAt = moment(deliveryDate).add(1, "day");

  // button should be enabled only if now is after enableAt
  const isButtonEnabled = moment().isAfter(enableAt);
  return (
    <div>
      {sortedProductServiceDeliveries.length < 1 ? (
        <div>
          {/* <EmptyState message="No work has been delivered for this service yet." /> */}
          <StyledNoUpcomingCallBox>
            <p className="info-text">No work has been delivered for this service yet.</p>
            {status === "inprogress" && (
              <Button
                onClick={() => {
                  dispatch({
                    type: "set-active-store-service-order-drawer",
                    payload: "cancel-order",
                  });
                }}
                type="text"
                size="small"
                disabled={!isButtonEnabled}
                title={
                  !isButtonEnabled
                    ? "You can only cancel a day after the delivery date"
                    : undefined
                }
              >
                <span style={{textDecoration: "underline"}}>Cancel order</span>
              </Button>
            )}
          </StyledNoUpcomingCallBox>
        </div>
      ) : (
        <Space size={16} direction="vertical" style={{display: "flex"}}>
          <Space size={16} direction="vertical" style={{display: "flex"}}>
            {sortedProductServiceDeliveries.map((d) => (
              <Fragment key={d.id}>
                <ServiceOrderWorkDeliveryDeliveredWorkLinkList
                  links={d.delivery
                    .filter((delivery) => !delivery.isUpload)
                    .map((delivery) => ({
                      link: delivery.key,
                    }))}
                  date={
                    sortedProductServiceDeliveries.length > 1
                      ? d.customer_comment
                        ? `Delivered on ${moment(d.createdAt).format(
                            "MMMM DD, YYYY • h:mm A"
                          )}`
                        : `Reviewed on ${moment(d.updatedAt).format(
                            "MMMM DD, YYYY • h:mm A"
                          )}`
                      : `Delivered on ${moment(d.createdAt).format(
                          "MMMM DD, YYYY • h:mm A"
                        )}`
                  }
                />
                {d.customer_comment && (
                  <ServiceOrderWorkDeliveryDeliveredWorkCustomerReview
                    customerReviewComment={d.customer_comment}
                    date={moment(d.updatedAt).format("MMMM DD, YYYY • h:mm A")}
                  />
                )}
              </Fragment>
            ))}
          </Space>
          {status === "delivered" && (
            <div style={{display: "flex", gap: "1.6rem", flexWrap: "wrap"}}>
              <Button
                size="small"
                block
                type="primary"
                onClick={() => {
                  dispatch({
                    type: "set-active-store-service-order-drawer",
                    payload: "approve-delivery",
                  });
                }}
              >
                Approve delivery
              </Button>
              <Tooltip
                title={hasBeenReviewed ? "Max number of revisions (1) reached" : null}
                color="black"
              >
                <Button
                  onClick={() => {
                    if (!hasBeenReviewed) {
                      dispatch({
                        type: "set-active-store-service-order-drawer",
                        payload: "request-review",
                      });
                    }
                  }}
                  size="small"
                  block
                  type="default"
                  disabled={hasBeenReviewed}
                >
                  Request revision
                </Button>
              </Tooltip>
              <Button
                onClick={() =>
                  dispatch({
                    type: "set-active-store-service-order-drawer",
                    payload: "open-dispute",
                  })
                }
                size="small"
                block
                type="text"
                danger
              >
                Open dispute
              </Button>
            </div>
          )}
        </Space>
      )}
    </div>
  );
}
